import { render, staticRenderFns } from "./selectDepartment.vue?vue&type=template&id=1176b5f7&scoped=true"
import script from "./selectDepartment.vue?vue&type=script&lang=js"
export * from "./selectDepartment.vue?vue&type=script&lang=js"
import style0 from "./selectDepartment.vue?vue&type=style&index=0&id=1176b5f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1176b5f7",
  null
  
)

export default component.exports